import { render, staticRenderFns } from "./Integer.vue?vue&type=template&id=94a5584e&scoped=true"
import script from "./Integer.vue?vue&type=script&lang=js"
export * from "./Integer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a5584e",
  null
  
)

export default component.exports